import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Row } from 'antd';
import logo from '../../../../assets/images/logo/hc_logo_2.svg';
import logoSmall from '../../../../assets/images/logo/hc_logo_1.svg';
import themeConfig from '../../../../configs/themeConfig';
import Config from '../../../../configs/appConfig';
import { IS_LOCAL_ENV } from '../../../../const/features';



const currentEnvLabel = (appEnv) => {
  const envMapping = {
    local: 'local',
    develop: 'dev',
    staging: 'qa',
  };

  return envMapping[appEnv] || '';
};


const MenuLogo = ({ onClose = () => {}, small = false }) => {
  return (
    <div className="hp-header-logo hp-d-flex hp-align-items-center" style={small ? { display: 'flex', flexDirection: 'column' } : {}}>
      <Link
        to="../"
        onClick={onClose}
        className="hp-position-relative hp-d-flex"
      >
        <img className="hp-logo" src={small ? logoSmall : logo} alt={small ? 'logo-sm' : 'logo-lg'} />
      </Link>

      <div className="hp-caption hp-font-weight-400 hp-text-color-primary-1">
        v.
        {themeConfig.version}
      </div>

      <Row gutter={[ 0, 16 ]} className="hp-mb-0 hp-mt-0">
        <div className='app-env-label' style={small ? { marginLeft: 'unset' } : {}}>
          {currentEnvLabel(!IS_LOCAL_ENV ? Config.VITE_APP_ENVIRONMENT : 'local')}
        </div>
      </Row>
    </div>
  );
};

MenuLogo.propTypes = {
  onClose: PropTypes.func,
  small: PropTypes.bool,
};

export default MenuLogo;
